import { keyframes, css } from 'styled-components';

const float = keyframes`
  0% {
    transform: translateY(-50%);
  }
  50% {
    transform: translateY(calc(-50% - 20px));
  }
  100% {
    transform: translateY(-50%);
  }
`;

const rotate = keyframes`
  from {
    transform: translateY(-50%) rotate(0deg);
  }
  to {
    transform: translateY(-50%) rotate(360deg);
  }
`;

const pulse = keyframes`
  0% {
    transform: translateY(-50%) scale(1);
    opacity: 0.1;
  }
  50% {
    transform: translateY(-50%) scale(1.1);
    opacity: 0.2;
  }
  100% {
    transform: translateY(-50%) scale(1);
    opacity: 0.1;
  }
`;

export const animations = {
  float: (duration = '6s', timing = 'ease-in-out') => css`
    ${float} ${duration} ${timing} infinite
  `,
  rotate: (duration = '20s', timing = 'linear') => css`
    ${rotate} ${duration} ${timing} infinite
  `,
  pulse: (duration = '4s', timing = 'ease-in-out') => css`
    ${pulse} ${duration} ${timing} infinite
  `
}; 